// extracted by mini-css-extract-plugin
export default {"menuBlock":"ZE-z","title":"_E-z","nav":"aF-z","flexCell":"bF-z","facetLink":"cF-z"};